import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-forbid-register-page',
  templateUrl: './forbid-register-page.component.html',
  styleUrls: ['./forbid-register-page.component.scss']
})
export class ForbidRegisterPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
